import $ from 'jquery';

export const match = (parameter) => {
    return Boolean(parameter.availableValues) && parameter.multivalue;
};

export const createEditor = (placeholder, options) => {
    var multiSelectElement = $(placeholder).html('<div></div>');
    var parameter,
        valueChangedCallback = options.parameterChanged,
        multiSelect;

    function onChange() {
        var val = multiSelect.value();
        valueChangedCallback(parameter, val);
    }

    return {
        beginEdit: function (param) {
            parameter = param;
            $(document).ready(function() {
                var checkInputs = function(elements) {
                    for (var i = 0; i < elements.length; i++) {
                        var input = $(elements[i]).find("input");
                        var isSelected = $(elements[i]).hasClass("k-selected");
                        input.prop("checked", isSelected);
                    }
                };

                $(multiSelectElement).kendoMultiSelect({
                    dataTextField: "name",
                    dataValueField: "value",
                    value: parameter.value || [],
                    dataSource: parameter.availableValues,
                    change: function() {
                        onChange();
                        var items = this.ul.find("li");
                        checkInputs(items);
                    },
                    placeholder: "Select...",
                    autoClose: false,
                    itemTemplate: "<input type='checkbox'/> #:data.name#",
                    dataBound: function() {
                        var items = this.ul.find("li");
                        setTimeout(function() {
                            checkInputs(items);
                            document.querySelectorAll('span.k-chip-action[title]').forEach(span => {
                                span.removeAttribute('title');
                            });
                        });                  
                    },
                    popup: {
                        appendTo: ".trv-parameter-container" 
                    }
                });

                multiSelect = $(multiSelectElement).data("kendoMultiSelect");
            });
        },
    };
};
